import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Prompt } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<UseQueryOptions<unknown, Error, Prompt>, 'queryKey' | 'queryFn'>;
}

export const usePromptSingleRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, Prompt>(
    [Entities.Prompts, id],
    async () => {
      const { data } = await api.v1AdminPromptsPromptIdGet(id)
      return data
    },
    { ...options }
  )
}
